<!--
  渠道类型P标签
-->
<template>
  <p class="tableP" :style="pStyle">
    {{ text }}
  </p>
</template>

<script>
import AES from "@/mixins/AES";
import { eventBus } from "@/plugins/eventBus";
export default {
  data() {
    return {
      text: "-",
      data: [],
      value: "",
    };
  },
  props: {
    id: {
      default() {
        return "";
      },
    },
    pStyle: {
      default() {
        return {};
      },
    },
  },
  methods: {
    getData(count = 0) {
      if (window.localStorage.getItem("channelType")) {
        //先查询是否存在渠道类型数据
        this.data = JSON.parse(
          AES.decrypt(window.localStorage.getItem("channelType"))
        );
        let text = this.data.filter((item) => item.dataDictionaryId == this.id);
        if (text.length === 0) {
          //没匹配到对应值
          this.text = "-";
        } else {
          this.text =
            this.$i18n.locale === "zh" ? text[0].cnName : text[0].enName;
        }
      } else {
        setTimeout(() => {
          this.getData(count + 1);
        }, 200);
        if (count == 17) {
          this.$api
            .post(
              "/api/DataDictionary/GetDataDictionaryCnEnID",
              "4356786200621312"
            )
            .then((res) => {
              window.localStorage.setItem(
                "channelType",
                AES.encrypt(JSON.stringify(res.data))
              );
              this.getData();
            });
        }
      }
    },
  },
  mounted() {
    eventBus.$emit("getChannelType");
    eventBus.$off("getChannelType");
    this.getData();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.getData();
      },
      immediate: true,
    },
    id(newValue) {
      this.value = newValue;
      this.getData();
    },
  },
};
</script>

<style></style>
